import { render, staticRenderFns } from "./LogoAbi.vue?vue&type=template&id=c41faba4&scoped=true&"
import script from "./LogoAbi.vue?vue&type=script&lang=js&"
export * from "./LogoAbi.vue?vue&type=script&lang=js&"
import style0 from "./LogoAbi.vue?vue&type=style&index=0&id=c41faba4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41faba4",
  null
  
)

export default component.exports